import { StoreState } from "store";

export const getSearchBoxState = (state: StoreState) => state.searchBoxState;
export const getFirstDepartureDate = (state: StoreState) => state.searchBoxState?.searchSegments?.[0]?.departureDate;
export const getLastArrivalDate = (state: StoreState) =>
  state.searchBoxState?.type === "ROUNDTRIP"
    ? state.searchBoxState?.searchSegments?.[state.searchBoxState?.searchSegments.length - 1]?.returnDate
    : state.searchBoxState?.type === "MULTISTOP"
    ? state.searchBoxState?.searchSegments?.[state.searchBoxState?.searchSegments.length - 1]?.departureDate
    : undefined;
export const getSearchType = (state: StoreState) => state.searchBoxState?.type;
